import styled from 'styled-components'
import React, { forwardRef } from 'react'
import { ClearFix } from 'components/common/ClearFix'
import {
  IconAlertTriangle,
  IconInfoCircle,
  IconInfoTriangle,
} from '@tabler/icons-react'
const Wrapper = styled.div<{ type: MessageType }>`
  border: ${({ theme }) => theme.message.borderProperties};
  background: ${({ theme }) => theme.message.backgroundColor};
  border-radius: 6px;
  padding: 12px 16px 12px 62px;
  margin: 16px 0;
  position: relative;

  border-color: ${({ type, theme }) =>
    type === 'error'
      ? theme.message.error.colour
      : type === 'info'
      ? theme.message.info.colour
      : theme.message.warn.colour};

  @media (min-width: 768px) {
    padding: 18px 24px 18px 107px;
  }
`

const MessageContent = styled.p`
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  margin: 0;
`

const MessageHeader = styled.h2`
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  margin: 0;
  margin-bottom: 1em;
`

const IconWrapper = styled.div<{ type: MessageType }>`
  position: absolute;
  left: 16px;
  top: 50%;
  width: 30px;
  transform: translateY(-50%);
  color: ${({ type, theme }) =>
    type === 'error'
      ? theme.message.error.colour
      : type === 'info'
      ? theme.message.info.colour
      : theme.message.warn.colour};
  @media (min-width: 768px) {
    width: 54px;
    left: 25px;
  }
`

type MessageType = 'error' | 'info' | 'warn'
type MessageProps = {
  heading?: React.ReactNode
  children: React.ReactNode
  type?: MessageType
}

export const Message = forwardRef<HTMLDivElement, MessageProps>(
  function Message({ heading, children, type = 'error' }: MessageProps, ref) {
    const Icon =
      type === 'error'
        ? IconAlertTriangle
        : type == 'info'
        ? IconInfoCircle
        : IconInfoTriangle

    return (
      <Wrapper type={type} ref={ref}>
        <IconWrapper type={type}>
          <Icon width='100%' height={undefined} />
        </IconWrapper>
        {!!heading && <MessageHeader>{heading}</MessageHeader>}
        <MessageContent>{children}</MessageContent>
        <ClearFix />
      </Wrapper>
    )
  },
)
